import { ModelTypes } from '@/typings/types/types';
import store from '@/store';
import { SectionType } from '@/typings/enums/enums';
import { EditingState } from '@/store/modules/editing/state';
import { CampaignState } from '@/models/CampaignModel';

export default function useNavigator(model: ModelTypes) {
  const campaignState = store.getters['campaign/state'] as CampaignState;
  const editingState = store.state.editing as EditingState;
  const state = model.state;

  const setFocus = () => {
    if (
      campaignState.isEditModeActive &&
      model.getSection().getSectionType() === editingState.activeTabCategory &&
      state.edit
    ) {
      state.edit = state.edit ?? {};
      state.edit.isFocus = true;
    }
  };

  const removeFocus = () => {
    if (campaignState.isEditModeActive && state.edit) {
      state.edit = state.edit ?? {};
      state.edit.isFocus = false;
    }
  };

  const removeActiveFromState = () => {
    if (state.edit) {
      state.edit = state.edit ?? {};
      state.edit.isActive = false;
    }
  };

  const toggleCollapse = () => {
    if (campaignState.isEditModeActive && state.edit) {
      state.edit = state.edit ?? {};
      state.edit.isCollapsed = !state.edit.isCollapsed;
    }
  };

  const isPopoverTab = () => {
    return editingState.activeTabCategory === SectionType.POPOVER;
  };
  const isSectionsTab = () => {
    return editingState.activeTabCategory === SectionType.SECTION;
  };
  const isFlowPagesTab = () => {
    return editingState.activeTabCategory === SectionType.FLOWPAGE;
  };

  return {
    isSectionsTab,
    isFlowPagesTab,
    isPopoverTab,
    setFocus,
    removeFocus,
    removeActiveFromState,
    toggleCollapse
  };
}
